/* AV LIBFIELD -- the library particle field ("assembling library": curl-noise star
 * drift -> the stars fly into a 16x9 wall of file-folder outlines).
 *
 * 2026-07-28: this engine used to live inline in snippets/av-hero-lib.liquid as the hero of the four
 * catalog pages. Those pages matter too much for search to carry a WebGL hero above the fold, so the
 * hero there became the lightweight Lite particle network and the field moved to the BOTTOM of the
 * same four pages, as the closing band that used to be the av-pg server corridor.
 *
 * Two mounting modes:
 *   BAND (window.AV_LIBBAND, set by sections/footer.liquid on the four catalog pages) — a
 *     self-contained full-bleed strip appended to the end of #MainContent, above the newsletter.
 *     No window rects, so the field fills the whole strip.
 *   CHAPTER (.av-edl--win[data-fx="libfield"]) — the homepage editorial contract shared with
 *     av-server.js / av-galaxy.js / av-libwall.js: the 3D shows ONLY through the section's window
 *     rects (divider band + .av-edl__mock cards), black elsewhere. Nothing uses this today; it is
 *     kept because the mask costs nothing when there are no windows and it makes the engine a
 *     drop-in for any chapter.
 *
 * Raw WebGL1, IO + reduced-motion + visibility safe, dpr-capped, mobile-lightened. */
(function () {
  if (window.__avLibfield) return; window.__avLibfield = 1;
  var MAXW = 8;

  function initOne(cv, host) {
    if (!cv || cv.__lfx) return; cv.__lfx = 1;
    var gl = cv.getContext('webgl', { alpha: false, antialias: true, premultipliedAlpha: false, powerPreference: 'low-power' }) || cv.getContext('experimental-webgl');
    if (!gl) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = (window.AV_PHONE === true) || (window.matchMedia && matchMedia('(hover:none),(pointer:coarse)').matches);

    /* ---------- window rects (UV space, y flipped) — same as every other chapter engine ---------- */
    var winEls = host.querySelectorAll ? host.querySelectorAll('.av-edl__divider, .av-edl__mock') : [];
    var BAND = winEls.length === 0;   /* no windows to mask through -> full-bleed band */
    var wins = new Float32Array(MAXW * 4);
    function computeWindows() {
      var i; for (i = 0; i < MAXW * 4; i++) wins[i] = 9.0;
      /* Band mode: one rect slightly larger than the canvas, so the SDF mask reads 1 everywhere and
         the per-vertex reject never fires. Costs one uniform instead of a second shader variant. */
      if (BAND) { wins[0] = -0.02; wins[1] = -0.02; wins[2] = 1.02; wins[3] = 1.02; return; }
      var cr = cv.getBoundingClientRect(); if (cr.width < 1 || cr.height < 1) return;
      var n = Math.min(winEls.length, MAXW);
      for (i = 0; i < n; i++) {
        var er = winEls[i].getBoundingClientRect();
        wins[i * 4] = (er.left - cr.left) / cr.width;
        wins[i * 4 + 1] = 1 - (er.bottom - cr.top) / cr.height;
        wins[i * 4 + 2] = (er.right - cr.left) / cr.width;
        wins[i * 4 + 3] = 1 - (er.top - cr.top) / cr.height;
      }
    }

    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) console.warn(gl.getShaderInfoLog(o)); return o; }
    function prog(v, f) { var p = gl.createProgram(); gl.attachShader(p, sh(gl.VERTEX_SHADER, v)); gl.attachShader(p, sh(gl.FRAGMENT_SHADER, f)); gl.linkProgram(p); return p; }

    /* ---------- nebula backdrop (the hero's fbm field, now window-masked) ---------- */
    var bgFS = ['precision highp float;',
      'uniform vec2 uRes;uniform float uTime;uniform vec2 uMouse;uniform float uScroll;uniform float uDim;',
      'uniform vec4 uWin[' + MAXW + '];uniform float uWinR;',
      'float hash(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
      'float vn(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.0-2.0*f);float a=hash(i),b=hash(i+vec2(1.,0.)),c=hash(i+vec2(0.,1.)),d=hash(i+vec2(1.,1.));return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);}',
      'float fbm(vec2 p){float s=0.,a=.5;for(int i=0;i<5;i++){s+=a*vn(p);p=p*2.03+vec2(7.1,3.7);a*=.5;}return s;}',
      /* rounded-rect SDF union of the window rects — identical to av-server.js so the soft edge matches */
      'float winMask(vec2 uv){float m=0.0;for(int i=0;i<' + MAXW + ';i++){vec4 w=uWin[i];vec2 cc=(w.xy+w.zw)*0.5;vec2 hh=(w.zw-w.xy)*0.5;vec2 d=abs(uv-cc)-hh+uWinR;float dist=length(max(d,0.0))+min(max(d.x,d.y),0.0)-uWinR;m=max(m,smoothstep(0.004,-0.004,dist));}return m;}',
      'void main(){vec2 uv=gl_FragCoord.xy/uRes;float m=winMask(uv);',
      /* early-out: the 5-octave fbm never runs on the black area between the windows */
      'if(m<0.003){gl_FragColor=vec4(0.,0.,0.,1.);return;}',
      'float asp=uRes.x/uRes.y;vec2 p=(uv-0.5);p.x*=asp;p+=(uMouse-0.5)*0.08;',
      'vec2 dM=(uv-uMouse)*vec2(asp,1.0);float dm=length(dM)+1e-3;float rip=exp(-dm*5.0)*sin(dm*17.0-uTime*4.5);p+=(dM/dm)*rip*0.055;',
      'float t=uTime*0.022+uScroll*0.5+0.1;float w=fbm(p*1.5+vec2(0.,t));vec2 wr=vec2(fbm(p*1.3+w+t),fbm(p*1.3-w-t*0.5))-0.5;',
      'float b1=fbm(p*vec2(1.1,1.7)+wr*1.5+vec2(t*0.4,-t));float au=pow(smoothstep(0.16,0.86,b1),1.15);',
      'vec3 cDeep=vec3(0.015,0.045,0.075),cTeal=vec3(0.05,0.22,0.30),cBlue=vec3(0.12,0.30,0.55),cVi=vec3(0.30,0.16,0.52);',
      'vec3 col=mix(cDeep,cTeal,au);col=mix(col,cBlue,smoothstep(0.45,1.0,au)*0.78);col=mix(col,cVi,smoothstep(0.7,1.15,au)*0.55);col*=1.3;col+=cDeep*0.78;',
      'float cg=exp(-length((uv-0.5)*vec2(asp,1.0))*2.2);col+=(cTeal*0.5+cBlue*0.5)*cg*0.6;',
      'float vig=smoothstep(1.42,0.30,length((uv-0.5)*vec2(asp,1.)*1.12));col*=0.30+0.70*vig;',
      'col+=(hash(uv*uRes+uTime)-0.5)*0.012;col*=max(0.0,1.0-uDim);col*=m;gl_FragColor=vec4(max(col,0.0),1.0);}'].join('');
    var bgP = prog('attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}', bgFS);
    var quad = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, quad);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var bgLoc = gl.getAttribLocation(bgP, 'p');
    var bgU = {
      res: gl.getUniformLocation(bgP, 'uRes'), time: gl.getUniformLocation(bgP, 'uTime'),
      mouse: gl.getUniformLocation(bgP, 'uMouse'), scroll: gl.getUniformLocation(bgP, 'uScroll'),
      win: gl.getUniformLocation(bgP, 'uWin[0]'), winR: gl.getUniformLocation(bgP, 'uWinR'),
      dim: gl.getUniformLocation(bgP, 'uDim')
    };

    /* ---------- the particle field (unchanged from the hero, plus the window test) ---------- */
    var ptVS = ['precision highp float;',
      'attribute vec3 aPos;attribute vec3 aCol;attribute float aSize;attribute float aSeed;attribute vec3 aSlot;attribute float aTrig;attribute float aBurst;',
      'uniform mat4 uMVP;uniform float uPx;uniform float uTime;uniform float uFlow;uniform vec3 uTrail[8];uniform vec3 uLib;',
      'uniform vec4 uWin[' + MAXW + '];',
      /* folder-open transition: uFocus = (cx,cy,halfW,halfH) of the chosen cell in world space,
         uFocusT dims + recedes every other folder, uOpenT swings the chosen folder's front flap
         open toward the camera, uScanX/uScanI drive the search sweep that brightens folders near
         the scanline, uBurstT launches the contents burst out of the opened folder. All default
         to no-op outside the transition. */
      'uniform vec4 uFocus;uniform float uFocusT;uniform float uOpenT;',
      'uniform float uScanX;uniform float uScanI;uniform float uBurstT;uniform float uFocusC;',
      /* threshold entry: uInsideT blacks out everything OUTSIDE the chosen folder (the wall recedes,
         one lit doorway remains), uEnterT dissolves the open flap in the last stretch of the
         dolly-through so it never clips the near plane */
      'uniform float uInsideT;uniform float uEnterT;',
      'varying vec3 vCol;varying float vT;varying float vAs;',
      'float hash3(vec3 p){p=fract(p*0.3183099+vec3(0.1,0.2,0.3));p*=17.0;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}',
      'float vnoise(vec3 x){vec3 i=floor(x),f=fract(x);f=f*f*(3.0-2.0*f);',
      'float n000=hash3(i+vec3(0.,0.,0.)),n100=hash3(i+vec3(1.,0.,0.)),n010=hash3(i+vec3(0.,1.,0.)),n110=hash3(i+vec3(1.,1.,0.));',
      'float n001=hash3(i+vec3(0.,0.,1.)),n101=hash3(i+vec3(1.,0.,1.)),n011=hash3(i+vec3(0.,1.,1.)),n111=hash3(i+vec3(1.,1.,1.));',
      'float nx00=mix(n000,n100,f.x),nx10=mix(n010,n110,f.x),nx01=mix(n001,n101,f.x),nx11=mix(n011,n111,f.x);',
      'return mix(mix(nx00,nx10,f.y),mix(nx01,nx11,f.y),f.z);}',
      'vec3 potential(vec3 p){float t=uTime*0.06;',
      'float a=vnoise(p*0.55+vec3(0.0,t,0.0));',
      'float b=vnoise(p*0.55+vec3(31.4,t*0.8+11.0,5.2));',
      'float c=vnoise(p*0.55+vec3(7.7,t*0.9-3.0,42.1));',
      'return vec3(a,b,c);}',
      'vec3 curl(vec3 p){float e=0.35;',
      'vec3 dx=vec3(e,0.0,0.0),dy=vec3(0.0,e,0.0),dz=vec3(0.0,0.0,e);',
      'vec3 px0=potential(p-dx),px1=potential(p+dx);',
      'vec3 py0=potential(p-dy),py1=potential(p+dy);',
      'vec3 pz0=potential(p-dz),pz1=potential(p+dz);',
      'float x=(py1.z-py0.z)-(pz1.y-pz0.y);',
      'float y=(pz1.x-pz0.x)-(px1.z-px0.z);',
      'float z=(px1.y-px0.y)-(py1.x-py0.x);',
      'return vec3(x,y,z)/(2.0*e);}',
      'void main(){',
      /* CONTENTS BURST: dedicated particles that live parked (size 0) until uBurstT rises, then
         stream out of the opened folder's mouth toward the camera. Each has its own start time
         (aSeed-staggered), so it reads as a continuous eruption, and each blows PAST the camera —
         the perspective clip removes it naturally right at the fly-by. */
      'if(aBurst>0.5){',
      'if(uBurstT<0.002){gl_PointSize=0.0;gl_Position=vec4(2.0,2.0,2.0,1.0);vCol=vec3(0.0);vT=0.0;vAs=0.0;return;}',
      'float t0=aSeed*0.55;float bt=clamp((uBurstT-t0)/max(0.05,1.0-t0),0.0,1.0);bt=bt*bt*(3.0-2.0*bt);',
      'if(bt<0.001){gl_PointSize=0.0;gl_Position=vec4(2.0,2.0,2.0,1.0);vCol=vec3(0.0);vT=0.0;vAs=0.0;return;}',
      'float bang=aSeed*43.97;',
      'vec2 bdir=vec2(cos(bang),sin(bang))*(0.2+0.8*fract(aSeed*13.7));',
      'vec3 bp=vec3(uFocus.x+bdir.x*bt*uFocus.z*7.0,uFocus.y+bdir.y*bt*uFocus.w*5.0+bt*bt*0.1,0.06+bt*(0.7+1.5*fract(aSeed*3.1)));',
      'vec4 bc=uMVP*vec4(bp,1.0);float bw=max(bc.w,0.12);',
      'gl_Position=bc;gl_PointSize=clamp(aSize*uPx/bw,1.0,64.0);',
      'vCol=aCol*(1.1+bt*1.5)*(1.0-bt*0.35);vT=0.8+0.5*sin(uTime*9.0+aSeed*40.0);vAs=1.0;return;}',
      'float as=smoothstep(0.0,1.0,clamp(aTrig,0.0,1.0));vAs=as;',
      'vec3 gp=aPos+curl(aPos+vec3(aSeed*4.0))*uFlow*(1.0-as*0.9);',
      'gp.y+=sin(uTime*0.25+aSeed*6.2831+aPos.x*0.4)*0.06*(1.0-as);',
      'vec3 wp=mix(gp,aSlot,as);',
      /* transition: everyone but the chosen folder falls away; the chosen one opens.
         relY: 0 at the folder's bottom edge (the hinge), ~2 at its top edge. Particles below the
         tab line (local y < 0.62) belong to the front flap and rotate about the hinge toward the
         camera; the tab and top edge stay put, so the silhouette reads as a folder opening. */
      'float inF=step(abs(aSlot.x-uFocus.x),uFocus.z*1.25)*step(abs(aSlot.y-uFocus.y),uFocus.w*1.25);',
      'wp.z-=uFocusT*(1.0-inF)*1.15;',
      'float relY=clamp((aSlot.y-uFocus.y)/max(uFocus.w,1e-4)+1.0,0.0,2.3);',
      'float isFront=inF*step((aSlot.y-uFocus.y)/max(uFocus.w,1e-4),0.62)*step(0.0005,uOpenT);',
      'float oa=uOpenT*1.5;',
      'wp.y=mix(wp.y,uFocus.y+(-1.0+cos(oa)*relY)*uFocus.w,isFront);',
      'wp.z=mix(wp.z,aSlot.z+sin(oa)*relY*uFocus.w,isFront);',
      'vec4 cp=uMVP*vec4(wp,1.0);float w=max(cp.w,0.15);vec2 ndc=cp.xy/w;',
      'float res=0.0;vec2 disp=vec2(0.0);float pn=vnoise(vec3(ndc*4.0,uTime*0.5));',
      'for(int i=0;i<8;i++){vec3 tp=uTrail[i];if(tp.z<=0.002)continue;vec2 dv=ndc-tp.xy;float d=length(dv)+1e-3;',
      'vec2 dir=dv/d;float ang=atan(dv.y,dv.x);',
      'float ph=d*15.0-uTime*4.3+pn*2.2+sin(ang*3.0-uTime*1.1)*0.9+sin(ang*6.0+uTime*0.6)*0.4;',
      'float env=exp(-d*4.2)*tp.z;float wv=sin(ph);vec2 tang=vec2(-dir.y,dir.x);',
      'disp+=(dir*wv+tang*cos(ph)*0.45)*env;res+=env*(0.5+0.5*wv);}',
      'ndc+=disp*0.095*(1.0-as);cp.xy=ndc*w;gl_Position=cp;',
      'gl_PointSize=clamp(aSize*uPx/w*(1.0+res*0.6+as*0.5),1.0,42.0);',
      /* search sweep: folders flare as the scanline passes over their column (assembled ones only) */
      'float scn=uScanI*exp(-abs(aSlot.x-uScanX)*2.6)*as;',
      'vCol=mix(aCol,uLib,as*0.55)*(1.0-0.78*uFocusT*(1.0-inF))*(1.0+inF*(0.35*uFocusT+1.1*uOpenT))*(1.0+scn*0.5);',
      /* THE FOUND ONE: the chosen folder recolors to the MATCH-FOUND lime — a short flare at the
         scan lock, then fully once the camera has arrived (uFocusC is timeline-driven, 0 idle) */
      'vCol=mix(vCol,vec3(0.80,1.0,0.22)*(1.15+0.9*uOpenT),inF*uFocusC*0.85);',
      'vCol*=(1.0-uInsideT*(1.0-inF));',
      /* CONDENSE: uEnterT now dissolves the WHOLE focused folder — its particles hand their light
         to the solid DOM plate forming on top of them (the "folder becomes an object" beat) */
      'vCol*=(1.0-uEnterT*inF);',
      'vT=0.5+0.5*sin(uTime*1.4+aSeed*30.0+aPos.z*5.0)+res*0.55+as*0.16+inF*(0.25*uFocusT+0.9*uOpenT+0.35*uFocusC)+scn*1.1;',
      /* WINDOW MASK: a point outside every window rect is discarded on the vertex stage — never
         rasterized, so the black area between the cards costs nothing but the vertex itself. */
      'vec2 uvp=ndc*0.5+0.5;float ins=0.0;',
      'for(int q=0;q<' + MAXW + ';q++){vec4 ww=uWin[q];if(uvp.x>=ww.x&&uvp.x<=ww.z&&uvp.y>=ww.y&&uvp.y<=ww.w)ins=1.0;}',
      'if(ins<0.5){gl_PointSize=0.0;gl_Position=vec4(2.0,2.0,2.0,1.0);}}'].join('');
    var ptFS = ['precision mediump float;varying vec3 vCol;varying float vT;varying float vAs;',
      'void main(){vec2 c=gl_PointCoord-0.5;float r=length(c);float a=smoothstep(0.5,0.10,r);a*=a;',
      'gl_FragColor=vec4(vCol*(0.62+0.95*max(vT,0.0))*(1.0+vAs*0.22),a);}'].join('');
    var ptP = prog(ptVS, ptFS);
    var ptU = {
      mvp: gl.getUniformLocation(ptP, 'uMVP'), px: gl.getUniformLocation(ptP, 'uPx'),
      time: gl.getUniformLocation(ptP, 'uTime'), flow: gl.getUniformLocation(ptP, 'uFlow'),
      trail: gl.getUniformLocation(ptP, 'uTrail[0]'), lib: gl.getUniformLocation(ptP, 'uLib'),
      win: gl.getUniformLocation(ptP, 'uWin[0]'),
      focus: gl.getUniformLocation(ptP, 'uFocus'), focusT: gl.getUniformLocation(ptP, 'uFocusT'),
      openT: gl.getUniformLocation(ptP, 'uOpenT'),
      scanX: gl.getUniformLocation(ptP, 'uScanX'), scanI: gl.getUniformLocation(ptP, 'uScanI'),
      burstT: gl.getUniformLocation(ptP, 'uBurstT'), focusC: gl.getUniformLocation(ptP, 'uFocusC'),
      insideT: gl.getUniformLocation(ptP, 'uInsideT'), enterT: gl.getUniformLocation(ptP, 'uEnterT')
    };
    var aPos = gl.getAttribLocation(ptP, 'aPos'), aCol = gl.getAttribLocation(ptP, 'aCol'),
      aSize = gl.getAttribLocation(ptP, 'aSize'), aSeed = gl.getAttribLocation(ptP, 'aSeed'),
      aSlot = gl.getAttribLocation(ptP, 'aSlot'), aTrig = gl.getAttribLocation(ptP, 'aTrig'),
      aBst = gl.getAttribLocation(ptP, 'aBurst');

    /* Point budget: the hero ran 38k/14k full-bleed. Here most points are masked away, but the vertex
       shader still runs for every one of them, so the count is trimmed — this replaces av-server.js,
       whose room+dust cloud was of the same order, keeping the homepage's total GPU load flat. */
    var N = coarse ? 11000 : 28000;
    /* BN=0 (2026-07-28): the contents burst was cut — the entry is now a clean threshold dolly
       through the folder mouth ("misraine" verdict from the owner). The burst machinery (aBurst
       attribute + shader branch) stays wired so it is one number away if ever wanted back. */
    var BN = 0, NT = N + BN;
    var pos = new Float32Array(NT * 3), col = new Float32Array(NT * 3), siz = new Float32Array(NT), seed = new Float32Array(NT);
    function hsv(h, s, v) { function f(n) { var k = (n + h * 6) % 6; return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0); } return [f(5), f(3), f(1)]; }
    for (var i = 0; i < N; i++) {
      var x = (Math.random() * 2 - 1) * 4.6;
      var y = (Math.random() * 2 - 1) * 2.0;
      var zr = Math.random();
      var z = (zr * zr * 2 - 1) * 5.5;
      var band = 0.5 + 0.5 * Math.sin(x * 0.5 + z * 0.4);
      pos[i * 3] = x; pos[i * 3 + 1] = y; pos[i * 3 + 2] = z;
      var u = Math.min(1, Math.max(0, 0.5 + 0.32 * (y / 2.0) + 0.30 * (band - 0.5) + (Math.random() - 0.5) * 0.28));
      var hue = 0.50 + 0.42 * Math.pow(u, 1.6);
      var c = hsv(hue, 0.72, 0.95);
      var br = 0.55 + 0.55 * band;
      if (Math.random() < 0.025) { c = [1.0, 0.95, 0.92]; br *= 1.15; }
      col[i * 3] = c[0] * br; col[i * 3 + 1] = c[1] * br; col[i * 3 + 2] = c[2] * br;
      siz[i] = (Math.random() < 0.04 ? 0.05 : 0.018) * (0.75 + Math.random() * 0.6);
      seed[i] = Math.random();
    }
    /* burst particles: bright cyan-white shards, a touch larger than the dust */
    for (var bi = N; bi < NT; bi++) {
      var bb = 0.8 + Math.random() * 0.45;
      col[bi * 3] = 0.75 * bb; col[bi * 3 + 1] = 0.93 * bb; col[bi * 3 + 2] = 1.0 * bb;
      siz[bi] = 0.026 + Math.random() * 0.034;
      seed[bi] = Math.random();
    }
    var bst = new Float32Array(NT);
    for (var bj = N; bj < NT; bj++) bst[bj] = 1;
    function buf(a) { var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, a, gl.STATIC_DRAW); return b; }
    var posB = buf(pos), colB = buf(col), sizB = buf(siz), seedB = buf(seed), bstB = buf(bst);

    /* ---------- LIBRARY assembly: stars fly into a grid wall of file-folder outlines ---------- */
    var CW = 16, CH = 9, NC = CW * CH, Wx = 3.9, Wy = 2.15;
    /* slot/trig are NT-sized: every enabled attribute must cover ALL drawn vertices (incl. burst),
       or WebGL rejects the draw. The burst tail stays zeroed — its branch never reads them. */
    var slot = new Float32Array(NT * 3), cellIdx = new Int32Array(N), trig = new Float32Array(NT);
    var cellW = 2 * Wx / CW, cellH = 2 * Wy / CH;
    var FB = 0.55, FT = -0.18;
    var fEdges = [[-1, -1, 1, -1], [1, -1, 1, FB], [1, FB, FT, FB], [FT, FB, FT, 1], [FT, 1, -1, 1], [-1, 1, -1, -1]];
    var fLen = [], fTot = 0;
    for (var fe = 0; fe < fEdges.length; fe++) { var s0 = fEdges[fe], dx0 = s0[2] - s0[0], dy0 = s0[3] - s0[1], Le = Math.sqrt(dx0 * dx0 + dy0 * dy0); fLen.push(Le); fTot += Le; }
    function folderPt() {
      if (Math.random() < 0.76) { var t = Math.random() * fTot, e = 0; while (e < fLen.length - 1 && t > fLen[e]) { t -= fLen[e]; e++; } var s = fEdges[e], f = t / fLen[e]; return [s[0] + (s[2] - s[0]) * f + (Math.random() - 0.5) * 0.05, s[1] + (s[3] - s[1]) * f + (Math.random() - 0.5) * 0.05]; }
      else if (Math.random() < 0.82) { return [(Math.random() * 2 - 1) * 0.9, -1 + Math.random() * (FB + 1) * 0.95]; }
      else { return [-1 + Math.random() * (FT + 1) * 0.9, FB + 0.04 + Math.random() * (0.96 - FB)]; }
    }
    for (var li = 0; li < N; li++) {
      var cell = li % NC, cx = cell % CW, cy = (cell - cx) / CW;
      var ccx = -Wx + (cx + 0.5) * cellW, ccy = Wy - (cy + 0.5) * cellH;
      var hw = cellW * 0.38, hh = cellH * 0.34;
      var fp = folderPt();
      slot[li * 3] = ccx + fp[0] * hw; slot[li * 3 + 1] = ccy + fp[1] * hh; slot[li * 3 + 2] = (Math.random() - 0.5) * 0.06;
      cellIdx[li] = cell; trig[li] = 0;
    }
    var slotB = buf(slot);
    var trigB = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, trigB); gl.bufferData(gl.ARRAY_BUFFER, trig, gl.DYNAMIC_DRAW);
    var cov = new Float32Array(NC), covS = new Float32Array(NC);
    var fillOrder = []; for (var foi = 0; foi < NC; foi++) fillOrder.push(foi);
    fillOrder.sort(function (a, b) { var ax = a % CW - (CW - 1) / 2, ay = (a - a % CW) / CW - (CH - 1) / 2, bx = b % CW - (CW - 1) / 2, by = (b - b % CW) / CW - (CH - 1) / 2; return (ax * ax + ay * ay) - (bx * bx + by * by); });
    var libMove = -9, autoFilled = 0, autoP = 0;

    /* ---------- matrices ---------- */
    function mPersp(fy, asp, n, f) { var t = 1 / Math.tan(fy / 2); return [t / asp, 0, 0, 0, 0, t, 0, 0, 0, 0, (f + n) / (n - f), -1, 0, 0, (2 * f * n) / (n - f), 0]; }
    function mTrans(x, y, z) { return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, x, y, z, 1]; }
    function mRX(a) { var c = Math.cos(a), s = Math.sin(a); return [1, 0, 0, 0, 0, c, s, 0, 0, -s, c, 0, 0, 0, 0, 1]; }
    function mRY(a) { var c = Math.cos(a), s = Math.sin(a); return [c, 0, -s, 0, 0, 1, 0, 0, s, 0, c, 0, 0, 0, 0, 1]; }
    function mMul(a, b) { var o = new Float32Array(16); for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) { var s = 0; for (var k = 0; k < 4; k++) s += a[k * 4 + r] * b[c * 4 + k]; o[c * 4 + r] = s; } return o; }

    /* band mode rasterizes the whole strip (nothing is masked away), so it renders at a slightly
       lower backing resolution than the chapter mode to keep the fill cost in the same place */
    var W = 2, H = 2, dpr = 1, RS = BAND ? 0.8 : 0.85, proj, uPx = 600, fov = 52 * Math.PI / 180;
    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 1.25);
      var r = cv.getBoundingClientRect();
      W = Math.max(2, Math.round((r.width || cv.clientWidth || 300) * dpr * RS));
      H = Math.max(2, Math.round((r.height || cv.clientHeight || 300) * dpr * RS));
      cv.width = W; cv.height = H; gl.viewport(0, 0, W, H);
      proj = mPersp(fov, W / H, 0.1, 100); uPx = H * 0.5 / Math.tan(fov * 0.5);
    }
    resize(); window.addEventListener('resize', resize, { passive: true });

    var mx = 0.5, my = 0.5, yaw = 0, pitch = 0, autoYaw = 0, scroll = 0;

    /* ================= folder-open transition (band pages only) =================
       Click a brand/model link -> the band rises fullscreen, the wall assembles fast, the camera
       flies to one folder (labeled with what was clicked), its flap swings open, light floods out,
       and the browser navigates to the collection. First time in a session: the full ~1.9s ride;
       after that a compressed ~0.95s version. Esc or any click skips straight to navigation.
       The band's own live canvas is ADOPTED into the fullscreen overlay (moving a canvas keeps its
       WebGL context), so there is no second context and no second shader compile at click time. */
    var T = null, fldxOv = null, fldxGlow = null, fldxLabel = null, fldxFlash = null, fldxHud = null, fldxDip = null;
    var F = { x: 999, y: 0, w: 1, h: 1 }, focusT = 0, openT = 0, panX = 0, panY = 0, scanX = 0, scanI = 0, burstT = 0, focusC = 0, insideT = 0, enterT = 0;
    /* the target folder is re-rolled on every ride (margin of 2 cols / 1 row keeps neighbours in
       frame at the fly-in distance); never the same cell twice in a row */
    var FCELL = { cx: 7, cy: 4 };
    function rollCell() {
      var last = -1;
      try { last = parseInt(sessionStorage.getItem('avFldxCell') || '-1', 10); } catch (e) { }
      var cx, cy, id, tries = 0;
      do {
        cx = 2 + Math.floor(Math.random() * 12);
        cy = 1 + Math.floor(Math.random() * 7);
        id = cy * CW + cx; tries++;
      } while (id === last && tries < 6);
      try { sessionStorage.setItem('avFldxCell', String(id)); } catch (e) { }
      FCELL = { cx: cx, cy: cy };
    }
    function easeIO(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function fldxBegin(href, label) {
      if (T) return;
      /* EVERY ride runs full pace (owner, same call as the BMX ride's v5.4): the compressed
         repeat show is retired -- impatience is served by CLICK/TAP TO SKIP. avFldxSeen is
         still written for a possible future opt-in. */
      var short = false;
      try { sessionStorage.setItem('avFldxSeen', '1'); } catch (e) { }
      try { var pl = document.createElement('link'); pl.rel = 'prefetch'; pl.href = href; document.head.appendChild(pl); } catch (e) { }
      fldxOv = document.createElement('div'); fldxOv.className = 'av-fldx' + (short ? ' av-fldx--short' : '');
      fldxOv.appendChild(cv);
      fldxGlow = null;   /* the mid-open glow div was cut with the burst — one light only: the final bloom */
      fldxLabel = document.createElement('div'); fldxLabel.className = 'av-fldx__label';
      fldxLabel.innerHTML = '<small>AutoVectors&nbsp;//&nbsp;Library</small><b></b>';
      /* two-tone: brand in white, model in cyan — built with text nodes, never innerHTML */
      (function (b) {
        var sep = label.indexOf(' — ');
        if (sep < 0) { b.textContent = label; return; }
        b.appendChild(document.createTextNode(label.slice(0, sep)));
        var mm = document.createElement('span'); mm.className = 'av-fldx__model';
        mm.textContent = ' — ' + label.slice(sep + 3);
        b.appendChild(mm);
      })(fldxLabel.querySelector('b'));
      fldxOv.appendChild(fldxLabel);
      var sk = document.createElement('div'); sk.className = 'av-fldx__skip'; sk.textContent = coarse ? 'TAP TO SKIP' : 'CLICK TO SKIP'; fldxOv.appendChild(sk);
      if (!short) {   /* search HUD — full ride only; the short version keeps its pace */
        fldxHud = document.createElement('div'); fldxHud.className = 'av-fldx__hud';
        var pc = parseInt(window.AV_LIBCOUNT || 0, 10);
        fldxHud.innerHTML = '<span class="dot"></span>SEARCHING LIBRARY' +
          (pc > 0 ? '&nbsp;&nbsp;<b>' + String(pc).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</b>&nbsp;PATTERNS' : '');
        fldxOv.appendChild(fldxHud);
      } else { fldxHud = null; }
      fldxFlash = null;   /* the bloom died with the morph design — the PLATE is the final object */
      fldxDip = document.createElement('div'); fldxDip.className = 'av-fldx__dip'; fldxOv.appendChild(fldxDip);
      document.body.appendChild(fldxOv);
      void fldxOv.offsetWidth;
      fldxOv.classList.add('is-up');
      rollCell();
      F = { x: -Wx + (FCELL.cx + 0.5) * cellW, y: Wy - (FCELL.cy + 0.5) * cellH, w: cellW * 0.38, h: cellH * 0.34 };
      libMove = -9e9;
      /* STAGE 1 -- COMPLETE THE LIBRARY from its CURRENT state (owner: the wall used to snap
         full at click -- "iskarto padaro kad visas library jau full"). Cells already visually
         complete are confirmed as-is; the unfinished ones flip on across a center-out WAVE
         (the ambient build's own fillOrder), its length proportional to what is missing:
         an untouched wall gets the whole ~0.9s build, a nearly-done wall a ~0.25s finish,
         a full wall skips the stage entirely. Later beats wait for the wave via T.shift.
         Applies to BOTH ride variants (the short ride no longer teleports to a finished wall). */
      var cj, fq = [];
      for (cj = 0; cj < NC; cj++) {
        var fc0 = fillOrder[cj];
        if (covS[fc0] >= 0.85) cov[fc0] = 1; else fq.push(fc0);
      }
      autoFilled = NC; autoP = NC;
      var missing = fq.length / NC;
      var fillS = short ? 60 : 180;
      /* wave pace ~30% slower than v1 (owner: "viskas per greit") -- empty wall: full ~1.17s, short ~0.66s */
      var fillD = fq.length ? Math.round(short ? 160 + 500 * missing : 260 + 910 * missing) : 0;
      var shift = fillD ? Math.max(0, fillS + fillD + 320 - (short ? 490 : 1050)) : 0;
      /* cam0 is FIXED, never derived from the band's scroll state: if the visitor had scrolled the
         band into view, `scroll` was high and the camera would start already ON the folder — the
         "folder pops in with no travel" bug. The overlay is fullscreen, so starting wide is always
         right. scroll is reset to match so the smoothing lerp can't drag the camera off the timeline. */
      scroll = 0;
      T = { t0: performance.now(), short: short, href: href, cam0: 4.6, navd: false, lab: 0, hud: 0, labelText: label || '',
            fillQ: fq, fillS: fillS, fillD: fillD, shift: shift };
      /* rAF can stall in a hidden tab — navigation must never be stranded on the timeline */
      T.safety = setTimeout(fldxGo, (short ? 1600 : 3550) + shift + 1400);
      fldxOv.addEventListener('pointerdown', fldxGo);
      document.addEventListener('keydown', fldxKey);
    }
    function fldxKey(e) { if (e.key === 'Escape' || e.key === 'Esc') fldxGo(); }
    function fldxGo() {
      if (!T || T.navd) return;
      T.navd = true; clearTimeout(T.safety);
      /* the handshake carries the folder label + ride variant so the arrival can open with the
         match-cut slate (full ride) or the compressed entrance (short ride) */
      try { sessionStorage.setItem('avFldx', JSON.stringify({ t: Date.now(), l: T.labelText, s: T.short ? 1 : 0, pr: T.plateRect || 0, vp: T.vp || 0 })); } catch (e) { }
      location.href = T.href;
    }
    function fldxTeardown() {   /* back/forward bfcache restore: put the canvas back into the band */
      if (T) clearTimeout(T.safety);
      document.removeEventListener('keydown', fldxKey);
      if (fldxOv) { host.insertBefore(cv, host.firstChild); fldxOv.remove(); fldxOv = null; }
      fldxHud = null; fldxDip = null;
      T = null; focusT = 0; openT = 0; panX = 0; panY = 0; scanX = 0; scanI = 0; burstT = 0; focusC = 0; insideT = 0; enterT = 0;
      F = { x: 999, y: 0, w: 1, h: 1 };
    }
    window.addEventListener('pageshow', function (ev) { if (ev.persisted && T) fldxTeardown(); });
    var MAXT = 8, trail = new Float32Array(MAXT * 3), thead = 0, lpx = -9, lpy = -9;
    function pushTrail(x, y) {
      var dx = x - lpx, dy = y - lpy;
      if (dx * dx + dy * dy < 0.0009) { trail[thead * 3] = x; trail[thead * 3 + 1] = y; trail[thead * 3 + 2] = 1.0; return; }
      thead = (thead + 1) % MAXT; trail[thead * 3] = x; trail[thead * 3 + 1] = y; trail[thead * 3 + 2] = 1.0; lpx = x; lpy = y;
    }
    if (!coarse) {
      window.addEventListener('pointermove', function (e) {
        if (T) return;   /* the transition owns the camera — no brushing, no trail waves */
        var r = cv.getBoundingClientRect(); if (e.clientY < r.top - 60 || e.clientY > r.bottom + 60) return;
        mx = (e.clientX - r.left) / r.width; my = (e.clientY - r.top) / r.height;
        pushTrail(mx * 2 - 1, 1 - my * 2); libMove = performance.now();
      }, { passive: true });
    }
    if (coarse) {
      /* touch classifier copied from the hero: vertical strokes / real page scroll stay SCROLL,
         horizontal-ish strokes on a still page steer + brush the wall */
      var tgSY = 0, tgX = 0, tgY = 0, tgCls = 0;
      var tgPlay = function (t) {
        if (tgCls === 2) return false;
        var sd = Math.abs((window.pageYOffset || 0) - tgSY);
        if (sd > (tgCls === 1 ? 30 : 4)) { tgCls = 2; return false; }
        if (tgCls === 1) return true;
        var dx = Math.abs(t.clientX - tgX), dy = Math.abs(t.clientY - tgY);
        if (dx * dx + dy * dy < 144) return false;
        if (dy > dx * 1.2) { tgCls = 2; return false; }
        tgCls = 1; return true;
      };
      window.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (!t) return; tgSY = window.pageYOffset || 0; tgX = t.clientX; tgY = t.clientY; tgCls = 0; }, { passive: true });
      window.addEventListener('touchmove', function (e) {
        if (T) return;
        var t = e.touches[0]; if (!t) return; if (!tgPlay(t)) return;
        var r = cv.getBoundingClientRect(); if (t.clientY < r.top - 60 || t.clientY > r.bottom + 60) return;
        mx = (t.clientX - r.left) / r.width; my = (t.clientY - r.top) / r.height;
        pushTrail(mx * 2 - 1, 1 - my * 2); libMove = performance.now();
      }, { passive: true });
      window.addEventListener('touchend', function () { tgCls = 2; }, { passive: true });
      window.addEventListener('touchcancel', function () { tgCls = 2; }, { passive: true });
    }

    /* the chapter is much taller than the old hero, so normalise over the whole host + one viewport,
       the same formula the other chapter engines use */
    function scrollProgress() {
      var rr = host.getBoundingClientRect();
      return Math.min(1, Math.max(0, (window.innerHeight * 0.5 - rr.top) / (rr.height + window.innerHeight)));
    }

    var vis = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: 0 }).observe(host);

    var t0 = performance.now(), raf = 0;
    function render(tm) {
      computeWindows();
      var tScroll = scrollProgress(); scroll += (tScroll - scroll) * 0.1;
      yaw += ((mx - 0.5) * 0.5 - yaw) * 0.05; pitch += ((my - 0.5) * 0.32 - pitch) * 0.05; autoYaw += 0.0011;
      for (var i = 0; i < MAXT; i++) { trail[i * 3 + 2] *= 0.955; }

      /* --- transition timeline: search sweep -> fly -> flap opens -> contents burst -> flash ---
         Full ride ~3.1s (scan beat is full-only); short ~1.35s keeps its pace, burst included. */
      if (T && !T.navd) {
        var te = performance.now() - T.t0, sh = T.short;
        /* ARRIVAL DOLLY: the ride used to open with the camera already parked at 4.6 — the 3D
           appeared out of nowhere ("teleportas"). Now it starts far out (8.4) and glides in over
           the first beat while the wall assembles, so you visibly TRAVEL into the library. Every
           later phase is shifted by that approach. */
        var APPD = sh ? 450 : 1000;   /* matches the 2x-slower overlay rise */
        var shf = T.shift || 0;       /* STAGE 1 wave pushes every later beat back by this much */
        /* "CONDENSE & CARRY" (the folder BECOMES the card): fly ends -> HOLD (folder lime, label
           on) -> SIMPLIFY (wall+nebula black out — one lit folder remains) -> CONDENSE (a solid
           DOM plate forms over the folder as its particles dissolve into it) -> DIP (black blink)
           -> navigate; the plate's exact rect rides the handshake and the ARRIVAL page reanimates
           it from that spot straight into the first product card. No flap, no bloom — the object
           itself is the show. */
        var flyS = (sh ? 490 : 1750) + shf, flyD = sh ? 530 : 1040,
          flyEnd = flyS + flyD,
          simpS = flyEnd + 40, simpD = sh ? 160 : 280,
          condS = flyEnd + (sh ? 80 : 150), condD = sh ? 180 : 220,
          dipS = condS + (sh ? 240 : 290), dipD = sh ? 120 : 140,
          navAt = (sh ? 1500 : 3420) + shf;
        /* STAGE 1 wave (replaces the old instant cov=1 fill): the unfinished cells flip on
           center-out across the fill window; cells beyond the wave keep their ambient state */
        if (T.fillD) {
          var fwv = Math.max(0, Math.min(1, (te - T.fillS) / T.fillD));
          var fUp = Math.round(T.fillQ.length * easeIO(fwv));
          for (var fc = 0; fc < fUp; fc++) cov[T.fillQ[fc]] = 1;
        }
        var fk = te < flyS ? 0 : easeIO(Math.min(1, (te - flyS) / flyD));
        focusT = Math.min(1, Math.max(0, (te - (flyS + flyD * 0.45)) / (flyD * 0.65)));
        openT = 0;   /* the folder stays closed — it condenses whole */
        insideT = te < simpS ? 0 : Math.min(1, (te - simpS) / simpD);
        enterT = te < condS ? 0 : Math.min(1, (te - condS) / condD);
        /* camera: arrival dolly (8.4 -> 4.6, easeOut), then the fly to the folder.
           PORTRAIT FIT: endD keeps the folder within ~72% of the frustum width on any screen;
           computed here because the CONDENSE block below projects the plate rect from it. */
        var ak = te >= APPD ? 1 : 1 - Math.pow(1 - te / APPD, 3);
        var baseD = 8.4 + (4.6 - 8.4) * ak;
        var endD = Math.max(0.68, F.w * 2.846 / (W / H));
        var camT = baseD + (endD - baseD) * fk;
        /* CONDENSE: the plate materializes exactly over the projected folder rect (once) */
        if (te >= condS && !T.plate) {
          T.plate = 1;
          var cssW = cv.clientWidth || window.innerWidth, cssH = cv.clientHeight || window.innerHeight;
          var factor = (cssH / 2) / (Math.max(0.2, endD) * Math.tan(fov / 2));
          var pw = Math.round(2 * F.w * factor * 1.06), ph = Math.round(2 * F.h * factor * 1.06);
          var px2 = Math.round((cssW - pw) / 2), py2 = Math.round((cssH - ph) / 2);
          T.plateRect = [px2, py2, pw, ph];
          T.vp = [window.innerWidth, window.innerHeight];
          var pl = document.createElement('div');
          pl.className = 'av-fldx__plate';
          pl.style.cssText = 'left:' + px2 + 'px;top:' + py2 + 'px;width:' + pw + 'px;height:' + ph + 'px;z-index:6;position:absolute';   /* ABOVE the dip (z5): the folder survives the cut visually */
          pl.innerHTML = '<div class="av-fldx__ptab"></div><div class="av-fldx__pbody"><small>AutoVectors&nbsp;//&nbsp;Library</small><b></b></div>';
          pl.querySelector('b').textContent = T.labelText || '';
          fldxOv.appendChild(pl);
          /* BIRTH TRACE: the site's lightning contour draws the plate into existence — the SAME
             pen as every card tracer (#9ff0ff, 2px, pad 2, rx 13, 230ms draw, fade by 620ms) */
          var tns = 'http://www.w3.org/2000/svg';
          var tsvg = document.createElementNS(tns, 'svg');
          tsvg.setAttribute('style', 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:4;overflow:visible');
          var tdefs = document.createElementNS(tns, 'defs');
          tdefs.innerHTML = '<filter id="av-fldx-tg" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="2.6" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>';
          tsvg.appendChild(tdefs);
          /* the trace follows the FOLDER silhouette — tab left 41% w / 22.5% h, the same shape
             the GL wall folders wear — not a plain rectangle */
          var fx = px2 - 2, fy = py2 - 2, fw = pw + 4, fh = ph + 4;
          var ftw = fw * 0.41, fth = fh * 0.225, fr = 14, fr2 = 10;
          var fd = 'M' + (fx + fr2) + ' ' + fy +
            'L' + (fx + ftw - fr2) + ' ' + fy + 'Q' + (fx + ftw) + ' ' + fy + ' ' + (fx + ftw) + ' ' + (fy + fr2) +
            'L' + (fx + ftw) + ' ' + (fy + fth) +
            'L' + (fx + fw - fr) + ' ' + (fy + fth) + 'Q' + (fx + fw) + ' ' + (fy + fth) + ' ' + (fx + fw) + ' ' + (fy + fth + fr) +
            'L' + (fx + fw) + ' ' + (fy + fh - fr) + 'Q' + (fx + fw) + ' ' + (fy + fh) + ' ' + (fx + fw - fr) + ' ' + (fy + fh) +
            'L' + (fx + fr) + ' ' + (fy + fh) + 'Q' + fx + ' ' + (fy + fh) + ' ' + fx + ' ' + (fy + fh - fr) +
            'L' + fx + ' ' + (fy + fr2) + 'Q' + fx + ' ' + fy + ' ' + (fx + fr2) + ' ' + fy + 'Z';
          var trect = document.createElementNS(tns, 'path');
          trect.setAttribute('d', fd); trect.setAttribute('fill', 'none');
          trect.setAttribute('stroke', '#9ff0ff'); trect.setAttribute('stroke-width', 2);
          trect.setAttribute('stroke-linejoin', 'round');
          trect.setAttribute('filter', 'url(#av-fldx-tg)');
          tsvg.appendChild(trect);
          fldxOv.appendChild(tsvg);
          var tper = trect.getTotalLength();
          trect.style.strokeDasharray = tper; trect.style.strokeDashoffset = tper;
          trect.animate([{ strokeDashoffset: tper }, { strokeDashoffset: 0 }], { duration: 230, easing: 'ease-out', fill: 'forwards' });
          trect.animate([{ opacity: 1, offset: 0 }, { opacity: 1, offset: 0.55 }, { opacity: 0, offset: 1 }],
            { duration: 620, easing: 'ease-out', fill: 'forwards' }).onfinish = function () { if (tsvg.parentNode) tsvg.remove(); };
          void pl.offsetWidth;
          pl.classList.add('is-in');
          if (fldxLabel && T.lab === 1) { T.lab = 2; fldxLabel.classList.remove('is-on'); }   /* the label moves ONTO the plate */
        }
        /* recolor of the found folder: NOT at the start — it blooms once the camera has ARRIVED
           (last 10% of the fly, 360ms ramp); on the full ride the scan lock adds a short partial
           flare much earlier, so you can spot which folder was found while still far away */
        focusC = te < flyS + flyD * 0.9 ? 0 : Math.min(1, (te - (flyS + flyD * 0.9)) / 360);
        if (!sh && te >= 1610 + shf) focusC = Math.max(focusC, 0.32 * Math.max(0, Math.min(1, scanI)));
        panX = F.x * fk; panY = F.y * fk;
        /* search sweep (full only): the scanline crosses the wall left-to-target, flickers as it
           locks, then hands off to the focus dim. HUD flips SEARCHING -> MATCH FOUND at the lock. */
        if (sh) { scanI = 0; }
        else {
          var scanS = 1050 + shf, scanD = 560, lockE = scanS + scanD + 200;
          if (te < scanS) scanI = 0;
          else if (te < scanS + scanD) {
            var skk = 1 - Math.pow(1 - (te - scanS) / scanD, 3);
            scanX = (-Wx - 0.5) + (F.x - (-Wx - 0.5)) * skk; scanI = 1;
          } else if (te < lockE) {
            scanX = F.x; scanI = 1 + 0.5 * Math.sin((te - scanS - scanD) * 0.047);
          } else { scanX = F.x; scanI = Math.max(0, 1 - (te - lockE) / 380); }
          if (fldxHud) {
            if (te >= scanS && T.hud === 0) { T.hud = 1; fldxHud.classList.add('is-on'); }
            if (te >= scanS + scanD && T.hud === 1) {
              T.hud = 2; fldxHud.classList.add('is-found');
              fldxHud.innerHTML = '<span class="dot"></span>MATCH FOUND';
            }
            if (te >= condS + 80 && T.hud === 2) { T.hud = 3; fldxHud.classList.remove('is-on'); }
          }
        }
        scroll = (4.6 - camT) / 3.4;   /* camDist below reproduces camT exactly */
        yaw *= 0.88; pitch *= 0.88;
        if (fldxLabel && fk > 0.75 && T.lab === 0) { T.lab = 1; fldxLabel.classList.add('is-on'); }
        /* the cut: black swallows the WORLD but NOT the plate (z6 > dip z5) — the frame the browser
           holds while loading is black + the folder, and the arrival pre-paints the IDENTICAL frame
           in <head>, so the object never blinks out across the navigation */
        var dT = te < dipS ? 0 : Math.min(1, (te - dipS) / dipD);
        if (fldxDip && dT > 0) fldxDip.style.opacity = dT.toFixed(3);
        if (te >= navAt) fldxGo();
      }

      /* --- assembly: the cursor brushes cells awake; left alone, the wall builds itself --- */
      var brushing = (performance.now() - libMove) < 1500;
      if (brushing) {
        var bcx = mx * CW, bcy = my * CH, br2 = 4.0;
        for (var cyi = 0; cyi < CH; cyi++) for (var cxi = 0; cxi < CW; cxi++) {
          var ddx = cxi + 0.5 - bcx, ddy = cyi + 0.5 - bcy, d2c = ddx * ddx + ddy * ddy;
          if (d2c < br2) { var v = 1.0 - d2c / br2; var ci = cyi * CW + cxi; if (v > cov[ci]) cov[ci] = v; }
        }
      } else if (autoFilled < NC) {
        autoP += NC / 840;
        var lim = Math.min(NC, autoP);
        while (autoFilled < lim) { cov[fillOrder[autoFilled]] = 1; autoFilled++; }
      }
      var asmCount = 0, ramping = false, covRate = T ? 0.115 : 0.07;   /* ride: each folder materializes ~30% gentler than v1 (owner slow-down) */
      for (var cj = 0; cj < NC; cj++) { var dd = cov[cj] - covS[cj]; if (dd > 0.0008 || dd < -0.0008) ramping = true; covS[cj] += dd * covRate; if (cov[cj] > 0.5) asmCount++; }
      var asm = asmCount / NC;
      if (brushing || ramping) {
        for (var ti = 0; ti < N; ti++) trig[ti] = covS[cellIdx[ti]];
        gl.bindBuffer(gl.ARRAY_BUFFER, trigB); gl.bufferSubData(gl.ARRAY_BUFFER, 0, trig);
      }

      var camDist = 4.6 - 3.4 * scroll;

      gl.clearColor(0.0, 0.0, 0.0, 1.0); gl.clear(gl.COLOR_BUFFER_BIT); gl.disable(gl.DEPTH_TEST);
      gl.disable(gl.BLEND); gl.useProgram(bgP);
      gl.bindBuffer(gl.ARRAY_BUFFER, quad); gl.enableVertexAttribArray(bgLoc); gl.vertexAttribPointer(bgLoc, 2, gl.FLOAT, false, 0, 0);
      gl.uniform2f(bgU.res, W, H); gl.uniform1f(bgU.time, tm); gl.uniform2f(bgU.mouse, mx, 1.0 - my); gl.uniform1f(bgU.scroll, scroll);
      /* bg dim: focus keeps the old gentle 45% cap; the threshold entry drives it to FULL black */
      gl.uniform4fv(bgU.win, wins); gl.uniform1f(bgU.winR, 0.014);
      gl.uniform1f(bgU.dim, Math.min(1, focusT * 0.45 + insideT));
      gl.drawArrays(gl.TRIANGLES, 0, 3);

      var rf = 1.0 - asm;
      var model = mMul(mRY((yaw + autoYaw) * rf), mRX(pitch * rf));
      var view = mTrans(-panX, -panY, -camDist);   /* pan centers the chosen folder during the fly-in */
      var mvp = mMul(proj, mMul(view, model));
      gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE); gl.useProgram(ptP);
      gl.bindBuffer(gl.ARRAY_BUFFER, posB); gl.enableVertexAttribArray(aPos); gl.vertexAttribPointer(aPos, 3, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, colB); gl.enableVertexAttribArray(aCol); gl.vertexAttribPointer(aCol, 3, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, sizB); gl.enableVertexAttribArray(aSize); gl.vertexAttribPointer(aSize, 1, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, seedB); gl.enableVertexAttribArray(aSeed); gl.vertexAttribPointer(aSeed, 1, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, slotB); gl.enableVertexAttribArray(aSlot); gl.vertexAttribPointer(aSlot, 3, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, trigB); gl.enableVertexAttribArray(aTrig); gl.vertexAttribPointer(aTrig, 1, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, bstB); gl.enableVertexAttribArray(aBst); gl.vertexAttribPointer(aBst, 1, gl.FLOAT, false, 0, 0);
      gl.uniformMatrix4fv(ptU.mvp, false, mvp); gl.uniform1f(ptU.px, uPx); gl.uniform1f(ptU.time, tm);
      gl.uniform1f(ptU.flow, reduce ? 0.18 : 0.9); gl.uniform3fv(ptU.trail, trail); gl.uniform3f(ptU.lib, 0.16, 0.60, 1.0);
      gl.uniform4fv(ptU.win, wins);
      gl.uniform4f(ptU.focus, F.x, F.y, F.w, F.h); gl.uniform1f(ptU.focusT, focusT); gl.uniform1f(ptU.openT, openT);
      gl.uniform1f(ptU.scanX, scanX); gl.uniform1f(ptU.scanI, scanI); gl.uniform1f(ptU.burstT, burstT);
      gl.uniform1f(ptU.focusC, focusC); gl.uniform1f(ptU.insideT, insideT); gl.uniform1f(ptU.enterT, enterT);
      gl.drawArrays(gl.POINTS, 0, NT);
    }

    function frame(now) {
      var r = cv.getBoundingClientRect();
      var nW = Math.max(2, Math.round((r.width || cv.clientWidth || 300) * dpr * RS)),
        nH = Math.max(2, Math.round((r.height || cv.clientHeight || 300) * dpr * RS));
      if (Math.abs(nW - W) > 2 || Math.abs(nH - H) > 2) { W = nW; H = nH; cv.width = W; cv.height = H; gl.viewport(0, 0, W, H); proj = mPersp(fov, W / H, 0.1, 100); uPx = H * 0.5 / Math.tan(fov * 0.5); }
      if (vis || T) render((now - t0) / 1000);   /* the band host is offscreen while its canvas plays the transition fullscreen */
      raf = requestAnimationFrame(frame);
    }
    if (reduce) { autoP = NC; autoFilled = 0; render(6.0); }
    else { raf = requestAnimationFrame(frame); }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { cancelAnimationFrame(raf); raf = 0; }
      else if (!raf && !reduce) { t0 = performance.now(); raf = requestAnimationFrame(frame); }
    });

    return { begin: fldxBegin, active: function () { return !!T; } };
  }

  function collect(root) {
    var out = [], wn = root.querySelectorAll ? root.querySelectorAll('.av-edl--win[data-fx="libfield"]') : [];
    for (var i = 0; i < wn.length; i++) { var c = wn[i].querySelector('.av-edl__bg .av-edl__canvas'); if (c) out.push([c, wn[i]]); }
    return out;
  }

  /* BAND: appended to the END of #MainContent, so the page title / brand grid / reviews all stay on
     flat black above it and the strip closes the page just before the newsletter — the same slot the
     av-pg server corridor used to occupy on the auto + moto pages. */
  function mountBand() {
    if (!window.AV_LIBBAND) return;
    var main = document.querySelector('#MainContent') || document.body;
    if (!main || main.querySelector('.av-libband')) return;
    var host = document.createElement('div'); host.className = 'av-libband';
    var cv = document.createElement('canvas'); cv.className = 'av-libband__canvas'; cv.setAttribute('aria-hidden', 'true');
    var scrim = document.createElement('div'); scrim.className = 'av-libband__scrim'; scrim.setAttribute('aria-hidden', 'true');
    host.appendChild(cv); host.appendChild(scrim);
    main.appendChild(host);
    var api = initOne(cv, host);
    if (!api) return;   /* no WebGL -> no engine -> links stay ordinary links */

    /* Brand + model links on the catalog pages leave through the folder — desktop grid
       (.av-card) AND the mobile accordion (.av-acc: model rows + the "View all X" brand link;
       the accordion summary itself only expands, so it is not intercepted). Capture phase so
       nothing else swallows the click first; modifier keys, middle click and reduced motion
       fall through to plain navigation. */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (api.active()) return;
      var a = e.target && e.target.closest ? e.target.closest('a.av-card-brand[href], a.av-model[href], a.av-acc-item[href], a.av-acc-all[href]') : null;
      if (!a) return;
      var inCard = a.closest('.av-card'), inAcc = a.closest('.av-acc');
      if (!inCard && !inAcc) return;
      if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (inAcc) {
        var bt = inAcc.querySelector('.av-acc-title');
        var an = bt ? (bt.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (a.classList.contains('av-acc-item')) { if (an) label = an + ' — ' + label; }
        else label = an || label;   /* "View all Acura →" reads as just the brand */
      } else if (a.classList.contains('av-model')) {
        var b = inCard.querySelector('.av-card-brand');
        var bn = b ? (b.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (bn) label = bn + ' — ' + label;
      }
      e.preventDefault();
      api.begin(href, label);
    }, true);
  }

  function initAll() { mountBand(); var l = collect(document); for (var i = 0; i < l.length; i++) initOne(l[i][0], l[i][1]); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) { var l = collect(e.target); for (var i = 0; i < l.length; i++) initOne(l[i][0], l[i][1]); });
})();
